import { SortOrder } from './types';

const serialize = (
  key: string,
  value: number | string | SortOrder | Record<string, string[]>
) => {
  if (value === undefined) {return '';}
  if (key === 'order') {
    //const order = value as SortOrder;
    return ''; // `sort=${order.direction === 'asc' ? '+' : '-'}${order.name}`
  }
  if (key === 'filter') {
    return ''; // `filter=${JSON.stringify(value)}`
  }
  return key + '=' + value;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toQueryString: (data?: Record<string, any>) => {
    if (!data) {return '';}
    return (
      '?' +
      Object.keys(data)
        .map((key) => serialize(key, (data as Record<string, any>)[key]))
        .filter((item) => item !== '')
        .join('&')
    );
  },
};
